/**
 * RecordingsStats - Stats display for recordings dashboard
 * Extracted from RecordingsTab.jsx
 */
import { formatViews } from "../utils";

export const RecordingsStats = ({ stats }) => (
  stats && (
    <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
      <div className="bg-zinc-900/50 border border-white/5 p-4">
        <p className="text-2xl font-bold text-white">{stats.total_recordings}</p>
        <p className="text-xs text-zinc-500 uppercase tracking-widest">Total</p>
      </div>
      <div className="bg-zinc-900/50 border border-white/5 p-4">
        <p className="text-2xl font-bold text-green-500">{stats.ready}</p>
        <p className="text-xs text-zinc-500 uppercase tracking-widest">Ready</p>
      </div>
      <div className="bg-zinc-900/50 border border-white/5 p-4">
        <p className="text-2xl font-bold text-blue-500">{stats.published}</p>
        <p className="text-xs text-zinc-500 uppercase tracking-widest">Published</p>
      </div>
      <div className="bg-zinc-900/50 border border-white/5 p-4">
        <p className="text-2xl font-bold text-yellow-500">{stats.processing}</p>
        <p className="text-xs text-zinc-500 uppercase tracking-widest">Processing</p>
      </div>
      <div className="bg-zinc-900/50 border border-white/5 p-4">
        <p className="text-2xl font-bold text-red-500">{stats.recording}</p>
        <p className="text-xs text-zinc-500 uppercase tracking-widest">Recording</p>
      </div>
      <div className="bg-zinc-900/50 border border-white/5 p-4">
        <p className="text-2xl font-bold text-white">{formatViews(stats.total_views)}</p>
        <p className="text-xs text-zinc-500 uppercase tracking-widest">Total Views</p>
      </div>
    </div>
  )
);

export default RecordingsStats;
